// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c3ea0836","389":"16f8d500","453":"74b6dbd0","455":"16eb27f6","977":"e4cd7ce0"}[chunkId] + ".chunk.js";
};